export default __webpack_public_path__ + "67c91b6a9d1e304a27229108808be073.svg";